export default __webpack_public_path__ + "static/media/style2.6cd69034.jpeg";